import { useCallback } from "react";

import { EventContentArg } from "@fullcalendar/common";
import cn from "classnames";
import { isPast } from "date-fns/esm";

import ActivityStatus from "@mapmycustomers/shared/enum/activity/ActivityStatus";

import EventObject from "@app/scene/activity/component/ActivityCalendarPage/type/EventObject";
import { UserColorClassNameGetter } from "@app/store/userColor/selectors";
import getActivityStatus from "@app/util/activity/getActivityStatus";
import isValidDate from "@app/util/isValidDate";
import { parseApiDate } from "@app/util/parsers";

import styles from "./useEventClassNamesGetter.module.scss";

const useEventClassNamesGetter = (getUserColor: UserColorClassNameGetter) =>
  useCallback(
    (args: EventContentArg): string => {
      const payload = args.event.extendedProps as EventObject;
      if (!payload) {
        return "";
      }
      const classes = [styles.container];
      if (payload.activity) {
        let colorByUser;
        if (payload.activity.assignee) {
          colorByUser = getUserColor(payload.activity.assignee);
        }
        if (colorByUser) {
          const startAt = parseApiDate(payload.activity.startAt ?? "");
          const endAt = parseApiDate(payload.activity.endAt ?? "");
          const isActivityInPast = isValidDate(endAt)
            ? isPast(endAt)
            : isValidDate(startAt) && isPast(startAt);

          classes.push(styles[`${colorByUser}${isActivityInPast ? "-in-past" : ""}`]);
        }
        if (ActivityStatus.COMPLETED === getActivityStatus(payload.activity)) {
          classes.push(styles.completed);
        }
      }
      if (payload.suggestion) {
        classes.push(styles[payload.suggestion.property.toLowerCase()]);
      }

      return cn(classes);
    },
    [getUserColor]
  );

export default useEventClassNamesGetter;
